import React from "react";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { WEB_BASE_URL } from "./webbase";
import QRCode from "react-qr-code";
import cookie from "react-cookies";

class AuthPage extends React.Component {
  constructor(props) {
    super(props);
    //props.location.state.secret
    //props.location.state.userEmailAddress
    console.log(props);
    this.state = {
      history: this.props.history,
      otp: "",
      secret: props.location.state.secret ? props.location.state.secret : "",
      authCode: "",
      token: props.location.state.token,
      if2FA: props.location.state.if2FA,
      user: props.location.state.user ? props.location.state.user : null,
      dealerId: props.location.state.dealerId
        ? props.location.state.dealerId
        : null,
      userRole: props.location.state.userRole
        ? props.location.state.userRole
        : null,
      userGroup: props.location.state.userGroup ? props.location.state.userGroup : null,
      sideBar: props.location.state.sideBar
        ? props.location.state.sideBar
        : null,
      comingFrom: props.location.state.comingFrom,
      userName: props.location.state.userName
        ? props.location.state.userName
        : null,

      description: props.location.state.description
        ? props.location.state.description
        : null,
      enterpriseToken: props.location.state?.unicardBalance,
      logicalState: props.location.state?.logicalState,
      unicardState: props.location.state?.unicardState,
      vasState: props.location.state?.vasState,
      accountNumber: props.location.state?.accountNumber,
      accountName: props.location.state?.accountName ,
      email:props.location.state?.email,
      bvnStatus:props.location.state?.bvnStatus                        
    };

    //bind functionsToOverrideByDerivedClasses
    this.onSubmit = this.onSubmit.bind(this);
  }

  //on TransactionPinChange
  on2FAChange = (e) => {
    this.setState({
      authCode: e.target.value,
    });
  };

  saveCookies = () => {
    console.log(this.state.vasState);
    cookie.save("token", this.state.token, {
      path: "/",
      expires: new Date(Date.now() + 60 * 27 * 1000),
    });
    cookie.save("user", this.state.user, {
      path: "/",
      expires: new Date(Date.now() + 60 * 27 * 1000),
    });
    cookie.save("dealerId", this.state.dealerId, {
      path: "/",
      expires: new Date(Date.now() + 60 * 27 * 1000),
    });
    cookie.save("userName", this.state.userName, {
      path: "/",
      expires: new Date(Date.now() + 60 * 27 * 1000),
    });
    cookie.save("userRole", this.state.userRole, {
      path: "/",
      expires: new Date(Date.now() + 60 * 27 * 1000),
    });
    cookie.save("userGroup", this.state.userGroup, {
      path: "/",
      expires: new Date(Date.now() + 60 * 27 * 1000),
    });
    cookie.save("sidebar", this.state.sideBar, {
      path: "/",
      expires: new Date(Date.now() + 60 * 27 * 1000),
    });
    cookie.save("description", this.state.description, {
      path: "/",
      expires: new Date(Date.now() + 60 * 27 * 1000),
    });
    cookie.save("enterpriseToken", this.state.enterpriseToken, {
      path: "/",
      expires: new Date(Date.now() + 60 * 27 * 1000),
    });
    cookie.save("activeProduct", "enterprise", {
      path: "/",
      expires: new Date(Date.now() + 60 * 27 * 1000),
    });
    cookie.save("vasState", this.state.vasState, {
      path: "/",
      expires: new Date(Date.now() + 60 * 27 * 1000),
    });
    cookie.save("accNo", this.state.accountNumber, {
      path: "/",
      expires: new Date(Date.now() + 60 * 27 * 1000),
    });
    cookie.save("accNa", this.state.accountName, {
      path: "/",
      expires: new Date(Date.now() + 60 * 27 * 1000),
    });
    cookie.save("emailAddress", this.state.email, {
      path: "/",
      expires: new Date(Date.now() + 60 * 27 * 1000),
    });
    cookie.save("bvnStatus", this.state.bvnStatus, {
      path: "/",
      expires: new Date(Date.now() + 60 * 27 * 1000),
    });
  };

  onSubmit = (event) => {
    event.preventDefault();
    const id = toast.loading("Please wait...");

    //axios post to sign in
    axios
      .post(
        WEB_BASE_URL + "/onboarding/validateTotp",
        {
          totp: this.state.authCode,
        },
        {
          headers: {
            authorization: this.state.token,
          },
        }
      )
      .then((res) => {
        if (res.data.status == 2000) {
          toast.update(id, {
            render: "Successfully Verified",
            type: "success",
            isLoading: false,
          });
          if (
            this.state.comingFrom === "verifyEmail" ||
            this.state.comingFrom === "complete-Signup"
          ) {
            this.props.navigate("/success-Page", {
              state: {
                secret: this.state.secret,
                token: this.state.token,
                if2FA: false,
                comingFrom: "verifyEmail",
              },
            });
          } else {
            this.saveCookies();

            if (
              this.state.description === "inactive"
            ) {
              this.props.navigate("/");
              this.props.navigate(0);
            } else {
              this.props.navigate("/");
              this.props.navigate(0);
            }
            return;
          }
        } else {
          // this.saveCookies();
          // this.props.navigate("/");
          // this.props.navigate(0);
          console.log({
            token: this.state.token,
            totp: this.state.authCode,
          });
          toast.update(id, {
            render: "" + res.data.description,
            type: "error",
            isLoading: false,
          });
        }
      })
      .catch((err) => {
        console.log({
          token: this.state.token,
          totp: this.state.authCode,
        });
        toast.update(id, {
          render: "" + err,
          type: "error",
          isLoading: false,
        });
      });
  };

  onResetPin = (event) => {
    event.preventDefault();
    const id = toast.loading("Please wait...");

    //axios post to sign in
    axios
      .get(WEB_BASE_URL + "/onboarding/forgot-pin", {
        headers: {
          authorization: this.state.token,
        },
      })
      .then((res) => {
        let iflog = res.data.status == 2000 ? true : false;

        if (iflog) {
          toast.update(id, {
            render: "OTP sent to your email",
            type: "success",
            isLoading: false,
          });

          this.props.navigate("/resetPin", {
            state: {
              token: this.state.token,
              requestID: res.data.data.requestId,
              userEmailAddress: this.state.formEmail,
            },
          });
        } else {
          console.log(res);
          toast.update(id, {
            render: "Invalid Credentials",
            type: "error",
            isLoading: false,
          });
          setTimeout(() => {
            toast.dismiss(id);
          }, 2000);
        }
      })
      .catch((err) => {
        toast.update(id, {
          render: "" + err,
          type: "error",
          isLoading: false,
        });
        setTimeout(() => {
          toast.dismiss(id);
        }, 2000);
      });
  };

  render() {
    return (
      <div>
        <ToastContainer
          position="top-center"
          autoClose={3000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
        <main className="authentication-content">
          <div className="container-fluid">
            <div className="authentication-card">
              <div className="card shadow rounded-0 overflow-hidden">
                <div className="row g-0">
                  <div className="col-lg-6 bg-login d-flex align-items-center justify-content-center">
                    <img
                      src="assets/images/error/login-img.png"
                      className="img-fluid"
                      alt=""
                    />
                  </div>
                  <div className="col-lg-6">
                    <div className="card-body p-4 p-sm-5">
                      <h5 className="card-title">
                        Topupbox - Two Factor Authentication
                      </h5>
                      <p>
                        <div></div>
                        <a href="https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2&hl=en&gl=US">
                          Click here to download Google Authenticator
                        </a>
                      </p>
                      <p>Account Email Address: {this.state.user}</p>
                      <form
                        className="form-body"
                        onSubmit={(event) => {
                          event.preventDefault();
                          this.onSubmit(event);
                        }}
                      >
                        <div className="row g-3">
                          <div className="col-12">
                            {this.state.if2FA ? (
                              <></>
                            ) : (
                              <>
                                <div>
                                  Scan Your QR with Google Authenticator App
                                </div>
                                <div
                                  style={{
                                    background: "white",
                                    padding: "10px",
                                  }}
                                >
                                  <img
                                    src={
                                      "data:image/png;base64, " +
                                      this.state.secret
                                    }
                                    alt="Red dot"
                                  />
                                </div>
                              </>
                            )}
                          </div>
                          <div className="col-12 ">
                            <div className="ms-auto position-relative">
                              <div className="position-absolute top-50 translate-middle-y search-icon px-3">
                                <i className="bi bi-lock-fill"></i>
                              </div>
                              <input
                                type="text"
                                className="form-control radius-30 ps-5"
                                id=""
                                placeholder="Enter Authenticator Code"
                                onChange={this.on2FAChange}
                                value={this.state.authCode}
                                required
                              />
                            </div>
                          </div>
                          <div className="col-6"></div>
                          <div class="col-6 text-end">
                            <a
                              href="/reset-pin"
                              onClick={(e) => {
                                e.preventDefault();
                                this.onResetPin(e);
                              }}
                            >
                              Reset Two Authenticator?
                            </a>
                          </div>
                          <div className="col-12">
                            <div className="d-grid">
                              <button
                                type="submit"
                                className="btn btn-primary radius-30"
                              >
                                Authenticate
                              </button>
                            </div>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </main>
      </div>
    );
  }

  componentDidMount() { }
}

export default AuthPage;
